//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    productTypeLabel: {
      type: String,
      default: 'product'
    },
    total: {
      type: String,
      default() {
        return '0'
      }
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      characterLimit: this.info.embossing_length || 6,
      text: '',
      font: 0,
      fonts: [
        {text: 'Classic'},
        {text: 'Modern'},
        {text: 'Script'},
      ],
    }
  },
  computed: {
    embossingPlaceholder() {
      return this.info.category_code === 'rings' ? this.$t('yourEmbossingHere') : this.$t('yourPersonalizationHere');
    }
  },
  methods: {
    changeQueryT() {
      document.querySelector('#engraving-input').blur();
      document.querySelector('#engraving-input').focus();
      const query = { ...this.$route.query, embossing: this.text };
      this.$router.replace({ query });
    },
    changeQueryF() {
      if (this.$route.query.f1 != this.font) {
        const query = { ...this.$route.query, f1: this.font };
        this.$router.replace({ query });
      }
    },
    back() {
      this.$parent.$emit('changeStage', 'configuration-edit')
    },
    close() {
      this.$parent.$emit('changeStage', 'configurator')
    }
  },
  mounted() {
    this.text =  this.$route.query.embossing ? this.$route.query.embossing : '';
  }
}
